import CardGroup from './CardGroup';
import Item from './Item';
import { consumer } from './context';
var Exports = CardGroup;
Exports.Item = consumer(Item);
Exports.displayName = 'ShineoutCardGroupItem';
Exports.displayName = 'ShineoutCardGroup';
export default Exports;